import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { CustomDateTimeDirective } from "./custom-date-time";

@NgModule({
  declarations: [CustomDateTimeDirective],
  imports: [CommonModule, FormsModule, IonicModule],
  exports: [CustomDateTimeDirective],
})
export class CustomDateTimeModule {}
